import { render, staticRenderFns } from "./FirstPageAfterPushOffer.vue?vue&type=template&id=b585fe04&scoped=true&"
import script from "./FirstPageAfterPushOffer.ts?vue&type=script&lang=ts&"
export * from "./FirstPageAfterPushOffer.ts?vue&type=script&lang=ts&"
import style0 from "./FirstPageAfterPushOffer.vue?vue&type=style&index=0&id=b585fe04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b585fe04",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn});
